import getBaseTickFormat from "../../helpers/getBaseTickFormat";
import getNiceTicks from "../../helpers/getNiceTicks";
import { VERTICAL_TICK_DIST } from "../../constants";

function calcTicks(chrs, chrSegments, xVisScale, isWg) {
  const { rangeDist, domainDist, scale } = xVisScale;
  const num = Math.round(rangeDist / VERTICAL_TICK_DIST);

  if (chrSegments.length === 1) {
    const { region, name } = chrSegments[0].chr;
    const { g0 } = region;
    return getNiceTicks(scale, num)
      .filter((g) => g - g0 >= 0)
      .map((g) => {
        const formated = getBaseTickFormat(g - g0, domainDist);
        const text = isWg ? `${name}: ${formated}` : formated;
        return { text, g };
      });
  }

  if (chrSegments.length > 8) {
    return chrs.map(({ shortName: text, region }) => ({
      text,
      g: region.g0 + 1,
    }));
  }

  return chrs.map(({ name: text, region }) => ({ text, g: region.g0 + 1 }));
}

export default calcTicks;
